export const BOOKING_STATUS = {
  INITIAL: "initial",
  CHECKED_IN: "checked_in",
  INITIATED: "initiated",
  PENDING_CHECK_IN: "pending_check_in",
  STUDENT_NOT_CHECKED_IN: "student_not_checked_in",
  COACH_NOT_INITIATED: "coach_not_initiated",
}

export const REFILLING_STEPS = {
  START_REFILLING: "START_REFILLING",
  REFILLING_CONFIRM: "REFILLING_CONFIRM",
  PAYMENT_PROCESS: "PAYMENT_PROCESS",
}

// booking time out after 15min
export const TIMEOUT = 1000 * 60 * 15



// WEBPACK FOOTER //
// ./src/constants/schedule.js